// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__EZFFT","main":"Profile_main__gdirg","done":"Profile_done__fIGhZ","favorite":"Profile_favorite__vhZnJ","logout":"Profile_logout__WdkU7"};